import { telemetryIncrementAction } from 'core-events/actions';
import { FocusEvent, useCallback, useRef } from 'react';

import { SIGNUP_FORM_STARTED_TAG } from './signUpTelemetry';

/**
 * Reports the first focus of a form field. The form also contains the terms links and the
 * show-password button, and focusing those is not starting the form, so only inputs count.
 */
export function useReportSignUpFormStarted(): (event: FocusEvent<HTMLElement>) => void {
    const hasReported = useRef(false);

    return useCallback((event: FocusEvent<HTMLElement>) => {
        if (hasReported.current || !(event.target instanceof HTMLInputElement)) {
            return;
        }
        hasReported.current = true;
        void telemetryIncrementAction(SIGNUP_FORM_STARTED_TAG);
    }, []);
}
